import React, {useEffect} from "react";
import { IonPopover, IonContent, IonButton } from '@ionic/react'
import { useRecoilState,useResetRecoilState } from "recoil";
import { userAuthDetail } from "../../store/atoms/userDetailAtom"
import { getMemberType } from "./handler"
import {  useHistory } from 'react-router-dom';



const HeaderComponent = (props) => {

    const [userAuthState, setUserAuthState] = useRecoilState(userAuthDetail);
    const resetUserAuth = useResetRecoilState(userAuthDetail);
    let history = useHistory()

   useEffect(()=>{
    getMemberType(userAuthState, setUserAuthState)
   })

    return (
        <>
            <div className='header-wrapper'>
                <img src="img/logo.png" className="logo" />
                <div className='logout-card desktop' id="click-trigger">
                    <ion-avatar slot="start">
                        <img src="../img/ryde-profile.png" />
                    </ion-avatar>
                    <ion-label>
                        <h2>RYDE Technologies Pte Ltd</h2>
                        <p> {userAuthState.firstName} | { userAuthState.memberType  } </p>
                        <img className='down-arrow' src="../img/down.svg" />
                    </ion-label>
                </div>
                <IonPopover trigger="click-trigger" triggerAction="click" dismissOnSelect={true}>
                    <IonContent class="ion-padding logout-popover">
                            <a><IonButton color="primary" mode='ios' onClick={()=>{
                                resetUserAuth()
                                history.push('/new/login')
                            }} >Logout</IonButton>
                       </a></IonContent>
                </IonPopover>

            </div>
        </>
    )
}

export default HeaderComponent;